// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/po/report.css
// module id = 2014
// module chunks = 0